import React, { useState } from "react";
import { Bookmark, Check, Trash2, Columns } from "lucide-react";
import { toast } from "sonner";
import { api, snapshotPreviewUrl } from "@/lib/api";

export const LookSnapshots = ({ projectId, snaps, mediaId, onChange }) => {
  const [name, setName] = useState("");
  const [sel, setSel] = useState([]);
  const toggle = (id) => setSel((s) => (s.includes(id) ? s.filter((x) => x !== id) : s.length >= 4 ? s : [...s, id]));
  const act = async (fn, msg) => { try { await fn(); toast.success(msg); onChange(); } catch (e) { toast.error(e?.response?.data?.detail || "Failed"); } };
  const save = () => act(() => api.saveSnapshot(projectId, name), `Saved “${name}”`).then(() => setName(""));
  const shown = snaps.filter((s) => sel.includes(s.id));

  return (
    <div className="space-y-3" data-testid="look-snapshots">
      <div className="flex items-center gap-2 flex-wrap">
        <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Name this look, e.g. “Warm Ceremony”"
          className="studio-input !py-1.5 text-sm max-w-xs" data-testid="snapshot-name-input" />
        <button className="btn btn-gold !py-1.5 text-sm" disabled={!name.trim()} onClick={save} data-testid="btn-save-snapshot"><Bookmark size={14} />Save current look</button>
        <span className="metric-label ml-auto"><Columns size={12} className="inline mr-1" />select 2–4 to compare</span>
      </div>
      {snaps.length === 0 ? <div className="studio-card p-5 text-sm text-[#64748B]" data-testid="snapshots-empty">No saved looks yet.</div> : (
        <div className="flex flex-wrap gap-2">
          {snaps.map((s) => (
            <div key={s.id} className={`studio-card px-3 py-2 flex items-center gap-2 ${sel.includes(s.id) ? "border-[#E6B04E]" : ""}`} data-testid={`snapshot-${s.id}`}>
              <input type="checkbox" checked={sel.includes(s.id)} onChange={() => toggle(s.id)} className="accent-[#E6B04E]" data-testid={`snapshot-select-${s.id}`} />
              <span className="text-sm font-semibold">{s.name}</span>
              <span className="metric-label" style={{ fontSize: 9 }}>{s.look?.creative_preset}</span>
              {s.active ? <span className="chip chip-KEEP" data-testid={`snapshot-active-${s.id}`}><Check size={10} />ACTIVE</span>
                : <button className="btn btn-ghost !py-0.5 !px-2 text-xs" onClick={() => act(() => api.activateSnapshot(projectId, s.id), `“${s.name}” is now used for render`)} data-testid={`snapshot-activate-${s.id}`}>Use for render</button>}
              <button className="text-[#64748B] hover:text-[#f87171]" onClick={() => act(() => api.deleteSnapshot(projectId, s.id), "Deleted")} data-testid={`snapshot-delete-${s.id}`}><Trash2 size={13} /></button>
            </div>
          ))}
        </div>
      )}
      {shown.length > 0 && mediaId && (
        <div className={`grid gap-3 ${shown.length > 2 ? "md:grid-cols-2 xl:grid-cols-4" : "md:grid-cols-2"}`} data-testid="snapshot-compare-grid">
          {shown.map((s) => (
            <div key={s.id} className="studio-card p-2">
              <img src={snapshotPreviewUrl(mediaId, s.id, s.created_at)} alt={s.name} className="w-full aspect-video object-contain bg-black rounded-md" data-testid={`snapshot-preview-${s.id}`} />
              <div className="text-xs font-semibold mt-1.5 px-1">{s.name}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
